<p>{{ 'exportCurrentSelectionEntities' | transloco }} {{ 'geometricAndTabularLayersWillBeExported' | transloco }}</p>

<app-expansion-panel [isExpanded]="true">
    <div
        class="!text-sm"
        header>
        {{ 'content' | transloco }}
    </div>
    <div
        class="flex flex-col gap-2 max-h-80 overflow-y-auto overflow-x-hidden"
        content>
        @if (dataExportService.isLoadingLayerNames()) {
            <app-loading />
        } @else if (selectedLayerRows().length) {
            <app-custom-table
                [columns]="tableColumns"
                (sortEvent)="onSort($event)">
                @for (layer of selectedLayerRows(); track layer.layerId) {
                    <tr>
                        <td class="table-raw min-w-25">{{ layer.layerName }}</td>
                        <td class="table-raw min-w-25">{{ layer.numberOfEntities }}</td>
                    </tr>
                }
            </app-custom-table>
        } @else {
            <span class="text-base w-full text-center">{{ 'noLayerSelected' | transloco }}</span>
        }
    </div>
</app-expansion-panel>
